import Link from 'next/link'

export const PoweredBy = () => {
	return (
		<div className='flex flex-row items-center gap-1'>
			<div className='text-sm'>Powered by</div>

			<Link
				href='https://scheduling.cocoon-space.com/'
				className='text-primary/80 text-sm font-bold underline'
				target='_blank'
			>
				cocoon space
			</Link>
		</div>
	)
}
